<template>
  <v-container class="py-8 px-10">
    <!-- Título principal -->
    <div class="text-h4 font-weight-bold mb-1">Dashboard de control</div>
    <div class="text-subtitle-1 mb-6">
      Aquí puedes ver un resumen de la actividad reciente de factoraje.
    </div>

    <v-row class="mb-6 no-gutters" elevation="4" style="border: 1px solid #e0e0e0; border-radius: 20px;">
      <!-- GMV principal -->
      <v-col cols="12" md="3">
        <v-card
          elevation="6"
          class="pa-6 text-center d-flex flex-column align-center justify-center white--text"
          style="
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
            height: 100%;
            background: linear-gradient(135deg, #1e3a8a, #3b82f6);
            margin-right: -1px; /* para unir sin espacio */
            z-index: 2;
          "
        >
          <v-icon large class="mb-2 white--text">mdi-cash-multiple</v-icon>
          <div style="font-family: 'montserrat-bold'; font-size: 24px;">${{ formatMoney(dashboard.revenue ? dashboard.revenue : 0) }} USD</div>
          <div style="font-family: 'montserrat-bold';" class="white--text">Revenue</div>
        </v-card>
      </v-col>

      <!-- Grupo de KPIs secundarios -->
      <v-col cols="12" md="9">
        <v-row no-gutters style="height: 100%;">
          <!-- Pendientes de cesión -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-radius: 0; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;">${{ formatMoney(dashboard.monto_financiado ? dashboard.monto_financiado : 0) }} USD</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Monto financiado</div>
            </v-card>
          </v-col>

          <!-- Por cobrar -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-radius: 0; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;">${{ formatMoney(dashboard.monto_cobrado ? dashboard.monto_cobrado : 0) }} USD</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Monto cobrado</div>
            </v-card>
          </v-col>

          <!-- Monto financiado -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-top-right-radius: 20px; border-bottom-right-radius: 20px; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;">${{ formatMoney(dashboard.monto_pendiente ? dashboard.monto_pendiente : 0) }} USD</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Monto por cobrar</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="mb-6" style="font-family: 'montserrat-bold'; font-size: 26px; color: #333;">
      Lista de facturas recientes
    </div>
    <v-data-table
      :items="invoices"
      hide-default-header
      style="background-color: transparent !important"
      >
      <template v-slot:header>
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">Cedente</th>
            <th class="header__title center">Deudor</th>
            <th class="header__title center">Id</th>
            <th class="header__title center">Reference</th>
            <th class="header__title center">Monto total</th>
            <th class="header__title center">Monto financiado</th>
            <th class="header__title center">Monto cobrado</th>
            <th class="header__title center">Revenue</th>
            <th class="header__title center">Fecha de emisión</th>
            <th class="header__title center">Fecha de vencimiento</th>
            <th class="header__title center">Status</th>
            <th class="header__title right">Acciones</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item center">{{ item.cedente_name }}</td>
            <td class="table__item center">{{ item.deudor_name }}</td>
            <td class="table__item center">{{ item.external_invoice_id }}</td>
            <td class="table__item center">{{ item.reference }}</td>
            <td class="table__item center">{{ formatMoney(item.monto_total - item.ajuste) }} USD</td>
            <td class="table__item center">${{ formatMoney(item.monto_adelantado) }} USD</td>
            <td class="table__item center" :style="{ color: parseFloat(item.monto_cobrado) > parseFloat(item.monto_adelantado) ? '#008000' : '#ff0000' }">${{ formatMoney(item.monto_cobrado) }} USD</td>
            <td class="table__item center">${{ formatMoney(item.profit ? item.profit : 0) }} USD</td>
            <td class="table__item center">{{ formatDate(item.fecha_emision) }}</td>
            <td class="table__item center" :style="{ color: new Date(item.fecha_vencimiento) < today ? item.estatus == 'adelantada' ? '#ff0000' : '#000000' : '#000000' }">{{ formatDate(item.fecha_vencimiento) }}</td>
            <td class="table__item center">
              <v-chip :color="statusColor(item.estatus)" small dark style="text-transform: capitalize;">{{ status[item.estatus] }}</v-chip>
            </td>
            <td class="table__item center">
              <v-btn color="black" icon @click="abrirDetalle(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import LineChart from '@/components/LineChart.vue'
import moment from "moment";

export default {
  components: {
    LineChart
  },
  data() {
    return {
      dashboard: [],
      invoices: [],
      today: new Date(),
      topDeudores: [
        { nombre: 'Grupo Y', monto: 85000 },
        { nombre: 'Grupo X', monto: 75000 },
        { nombre: 'Grupo Z', monto: 50000 },
        { nombre: 'Innova S.A.', monto: 45000 },
        { nombre: 'Fábrica Uno', monto: 40000 }
      ],
      status: {
        subida: 'Por validar',
        validada: 'Por aprobar',
        aprobada: 'Por adelantar',
        adelantada: 'Por cobrar',
        cobrada: 'Por liquidar',
        liquidada: 'Liquidadas',
      }
    }
  },
  computed: {
    montoCedido() {
      return this.facturas
        .filter(f => f.estado === 'aprobada')
        .reduce((sum, f) => sum + f.monto, 0)
    },
    montoFinanciado() {
      return this.facturas
        .filter(f => f.montoFinanciado)
        .reduce((sum, f) => sum + f.montoFinanciado, 0)
    },
    montoVencido() {
      const hoy = new Date()
      return this.facturas
        .filter(f => f.estado !== 'pagada' && new Date(f.fechaVencimiento) < hoy)
        .reduce((sum, f) => sum + f.monto, 0)
    },
    usoGlobal() {
      return Math.round((this.lineaUsada / this.lineaTotal) * 100)
    },
    kpisPrincipales() {
      return [
        { label: 'Pendientes de cesión', valor: 33000 },
        { label: 'Monto cedido', valor: this.montoCedido },
        { label: 'Monto financiado', valor: this.montoFinanciado },
        { label: 'Facturas vencidas', valor: this.montoVencido }
      ]
    },
    maxMontoDeudores() {
      return Math.max(...this.topDeudores.map(d => d.monto))
    }
  },
  methods: {
    async getDashboard() {
      try {
        const response = await DB.get(`${URI}/api/v1/en/factoring/dashboard`, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        })
        this.dashboard = response.data.dashboard;
        this.invoices = response.data.factoringInvoices;
        this.chartLabels = this.dashboard.months
        this.chartData = this.dashboard.profits
      } catch (err) {
        console.error(err)
      }
    },  
    statusColor(status) {
      return {
        subida: 'blue',
        validada: 'blue',
        aprobada: 'green',
        adelantada: 'orange',
        cobrada: 'purple',
        liquidada: 'grey',
      }[status] || 'grey';
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    abrirDetalle(factura) {
      this.$router.push({
        name: 'FacturaDeudorDetalle',
        params: { invoiceId: factura.id }
      });
    },
  },
  mounted() {
    this.getDashboard();
  }
}
</script>

<style scoped>
.gradient-card {
  background: linear-gradient(to bottom, #333, #000);
  border-radius: 12px;
  color: white;
}
</style>
